import React, { useContext, useEffect } from 'react'
import { DemoContext } from '../lib/DemoProvider'
import Wait from '@react/react-spectrum/Wait'
import Well from '@react/react-spectrum/Well'
import Button from '@react/react-spectrum/Button'
import analytics from '../config/analytics'

export default function Outputs () {
    const { selectedFiles, refineFiles, wait, apiStatus, outputComps, dispatch, page } = useContext(DemoContext)

    useEffect(() => {
        getCutout()
        document.querySelectorAll('remove-background').forEach( rbs => {
            if (rbs.shadowRoot.querySelector('.masked-data')) {
                rbs.shadowRoot.querySelector('.masked-data').style.width = '400px'
            } 
        }) 

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refineFiles.length, selectedFiles.length])

    // function downloadCutoutImage(target) {
    //     analytics.sendEventName('click', `${page}:downloadCutout`)
    //     window.downloadCutout(target)
    // }

    // function downloadCutoutMask(target) {
    //     analytics.sendEventName('click', `${page}:downloadMask`)
    //     window.downloadMask(target)
    // }
    function editCutout(target, name) {
        analytics.sendEventName('click', `${page}:${name}:downloadCutout`)
        window.editCutout(target)
    }

    // function saveCutout(target, name) {
    //     analytics.sendEventName('click', `${page}:${name}:downloadCutout`)
    //     window.saveCutout(target, name)
    // }

    function downloadCutout(target, name) {
        analytics.sendEventName('click', `${page}:${name}:downloadCutout`)
        window.downloadCutout(target, name)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    function getCutout() {
        let comps = null
        if (selectedFiles && selectedFiles.length > 0 && refineFiles && refineFiles.length > 0) {
            // dispatch({ type: 'set-wait', payload: {wait: false} })
            comps = refineFiles.map( file => {
                if (file.aperitif) {
                    const input = file.aperitif.urls[0].get
                    const output = file.aperitif.urls[1].get
                    return <div className="adobe-table" key={file.aperitif.urls[0].id}>
                        <div className='adobe-remove-background'>
                            <remove-background
                                image-data={input}
                                cutout-data={output}>
                            </remove-background>
                        </div>
                        <div className="adobe-download-buttons">
                            <Button variant="action" onClick={ e => editCutout(input, 'edit')}>Edit</Button>
                            {/* <Button variant="action" onClick={ e => saveCutout(e.target, 'save')}>Save</Button> */}
                            <Button variant="action" onClick={ e => downloadCutout(input, 'download')}>Download</Button>
                        </div>
                    </div>
                } else {
                    return null
                }
            })
            dispatch({ type: 'set-outputComps', payload: {outputComps: <React.Fragment><p>Click an image below to launch Remove Background Editor</p><Well><div className='adobe-app-wrap'>{comps}</div></Well></React.Fragment>} })
        }
    }
    if (wait) {
        return <div className="modal-loading">
                <Wait size="L" />
            <div>{apiStatus}</div>
        </div>
    }
    return <div id="adobe-app-outputs">{outputComps}</div>
}
